import quickLinkApi from "../api/quick-link-api";

/**
 * NMU-608: ทางลัดด่วน.
 *
 * A bare-bean endpoint like Intranet and Slider, so `status` on a quick link is
 * the published flag, not an envelope verdict — only a *string* status means the
 * call itself failed (NMU-453).
 */
const assertSuccess = (resp) => {
    if (resp && typeof resp.status === "string" && resp.status !== "SUCCESS") {
        throw resp.responseMsgTh || resp.responseMsgEn || resp.message || resp.status;
    }
    return resp;
};

const normalizeList = (resp) => {
    if (!resp) return [];
    if (Array.isArray(resp)) return resp;
    const raw = resp.data || resp.list;
    return Array.isArray(raw) ? raw : [];
};

/** The list arrives in display order — the service sorts by ลำดับ. */
const list = async () => normalizeList(await quickLinkApi.list());

const add = async (bean) => assertSuccess(await quickLinkApi.add(bean));
const edit = async (id, bean) => assertSuccess(await quickLinkApi.edit(id, bean));
const remove = async (id) => assertSuccess(await quickLinkApi.remove(id));

const quickLinkService = { list, add, edit, remove };

export default quickLinkService;
